import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useUserStore } from "../../store/userStore";
import CustomButton from "../CustomButton";

import "./style.scss";

export const SetupUserPopup = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { user } = useUserStore();

  const [showPopup, setShowPopup] = useState(false);
  useEffect(() => {
    if (user && !user.phoneNumberConfirmed && pathname === "/sessions") {
      setShowPopup(true);
    }
  }, [user]);

  const handleSkip = () => {
    setShowPopup(false);
  };

  const goSettingsPage = () => {
    navigate("/profile?isSetUp=true");
    setShowPopup(false);
  };

  if (!showPopup) return null;

  return (
    <div className="overlay">
      <div className="popup">
        <h2 className="popup-title">{t("setup_popup_title")}</h2>
        <p className="popup-message">{t("setup_popup_text1")}</p>
        <p className="popup-message">{t("setup_popup_text2")}</p>
        <p className="popup-message">{t("setup_popup_text3")}</p>
        <div className="setup-modal-buttons-container">
          <CustomButton onClick={goSettingsPage}>
            {t("setup_popup_go_settings")}
          </CustomButton>
          <button className="skip" onClick={handleSkip}>
            {t("setup_popup_skip")}
          </button>
        </div>
      </div>
    </div>
  );
};
